module.exports = __webpack_public_path__ + "img/bank_icon15.d7fb2164.png";